angular.module("notifications").directive("notificationsBox", [function () {
    return {
        restrict: 'E',
        scope: {
            closeFunction: '='
        },
        templateUrl: '../notifications/notifications-box.tpl',
        controller: 'notifications.NotificationsBoxCtrl',
        controllerAs: 'notificationsBox'
    };
}]);
